var FeedbackFormatter = {
	format: function (feedbackItem, dynamicData) {

		var transformedText = FeedbackFormatter.insertDynamicData(this.determineText(feedbackItem), dynamicData);

		// Split out the large paragraphs
		var paragraphs = transformedText.split("\n\n");

		return _.map(paragraphs, function(text, index) {

			var paragraphStyle = {};

			if (text.startsWith(">>")) {
				paragraphStyle["paddingLeft"] = 10;
				paragraphStyle["fontStyle"] = "italic";
				paragraphStyle["borderLeft"] = "solid 1px #ddd";
				text = text.substring(2);
			}

			// Split up line results within paragraph
			var lines = text.split("\n");
			var paragraphContent = [];

			_.each(lines, function(line, index) {
				var lineContent = FeedbackFormatter.formatHelper(line);
				if (index > 0) {
					paragraphContent.push(<span>{" "}<br key={ "br-" + index } /></span>);
				}
				paragraphContent.push(<span key={ "line-" + index }>{ lineContent }</span>);
			}.bind(this));

			return (
				<p key={ index } style={ paragraphStyle }>
					{ paragraphContent }{" "}
				</p>
			);
		}.bind(this));
	},

	formatSimple(text, dynamicData) {
		if (dynamicData) {
			var text = FeedbackFormatter.insertDynamicData(this.determineText(text), dynamicData);
		}
		return FeedbackFormatter.formatHelper(text);
	},

	insertDynamicData(text, dynamicData) {
		text = this.determineText(text) || "";

		if (dynamicData === undefined) {
			dynamicData = FeedbackFormatter.DEFAULT_SUBS;
		}

		if (dynamicData.firstName !== undefined) {
			text = text.replace(/\$NAME/g, dynamicData.firstName);
		}

		if (dynamicData.bookTitle !== undefined) {
			text = text.replace(/\$BOOK-TITLE/g, dynamicData.bookTitle);
		}

		if (dynamicData.textVariety !== undefined) {
			var varietyChoiceRegex = /\$TEXT-VARIETY\([\w\| ]*\)/;
			var varietyChoiceIndex = (dynamicData.textVariety == "fiction") ? 0 : 1;

			text = FeedbackFormatter.substituteChoices(text, varietyChoiceRegex, varietyChoiceIndex);
		}

		return text;
	},

	formatHelper(text, contentList) {
		text = this.determineText(text);
		var contentList = [];

		var bestFormatting = undefined;
		var bestMatch = undefined;

		for (var i = 0; i < FeedbackFormatter.FORMAT_DETAILS.length; i += 1) {
			var formattingDetails = FeedbackFormatter.FORMAT_DETAILS[i];
			var regex = new RegExp(formattingDetails.pattern);

			var match = regex.exec(text);
			if (match && (bestMatch == undefined || match.index < bestMatch.index)) {
				bestFormatting = formattingDetails;
				bestMatch = match;
			}
		}

		if (bestFormatting) {
			if (bestMatch.index > 0) {
				// Add the text that comes before the formattingmatch
				contentList.push(
					<span key={ contentList.length }>
						{ text.substring(0, bestMatch.index) }
					</span>
				);
			}

			var matchContent = bestMatch[0];
			if (bestFormatting.handler) {
				var formattedMatchContents = bestFormatting.handler(matchContent)

			} else if (bestFormatting.style) {
				// Add the inner contents of the match, after applying formatting & recursing
				var stripRegex = new RegExp(bestFormatting.stripChar, "g");
				var cleanText = matchContent.replace(stripRegex, "");
				var formattedMatchContents = FeedbackFormatter.formatHelper(cleanText);
			}
			contentList.push(
				<span key={ contentList.length } style={ bestFormatting.style }>
					{ formattedMatchContents }
				</span>
			);

			var nextIndex = bestMatch.index + matchContent.length;
			if (nextIndex < text.length) {
				// Add text that comes after the match, recursing to apply additional formatting
				var afterContent = text.substring(nextIndex);
				var formattedAfterContents = FeedbackFormatter.formatHelper(afterContent);
				contentList.push(
					<span key={ contentList.length }>
						{ formattedAfterContents }
					</span>
				);
			}

		} else {
			// Add the content with no formatting
			contentList.push(
				<span key={ contentList.length }>
					{ text }
				</span>
			);

		}

		return contentList;
	},

	formatLink(linkText) {
		var linkParks = linkText.split(/[\(\|\)]/g);
		if (linkParks[0] == "BUTTON") {
			var linkClassName = "btn buttonPrimary";
		}
		return (
			<a href={ linkParks[2] } className={ linkClassName } target="_blank">
				{ linkParks[1] }
			</a>
		);
	},

	substituteChoices(text, regex, choiceIndex) {
		text = this.determineText(text);
		var match = text.match(regex);
		if (text.match(regex)) {
			var matchContent = match[0];
			var pluralOptions = matchContent.split("(")[1].split(")")[0].split("|");

			var newText = text.replace(regex, pluralOptions[choiceIndex]);

			return FeedbackFormatter.substituteChoices(newText, regex, choiceIndex);

		} else {
			return text;
		}
	},
	// if text is an object due to recent changes in ag feedback (7/2021)
	// extract the feedback text
	determineText(text) {
		if (typeof text === 'object' && text.content) {
			return _.first(text.content)
		} else {
			return text
		}
	}

}

FeedbackFormatter.FORMAT_DETAILS = [
	{ name: "link", pattern: "(LINK|BUTTON)\\([^\\(\\)\\|]*\\|[^\\(\\)\\|]*\\)", handler: FeedbackFormatter.formatLink },
	{ name: "underline", pattern: "_[^_]+_", stripChar: "_", style: { textDecoration: "underline" } },
	{ name: "bold", pattern: "\\*[^\\*]+\\*", stripChar: "\\*", style: { fontWeight: "bold" } },
	{ name: "italic", pattern: "\\/[^\\/]+\\/", stripChar: "\\/", style: { fontStyle: "italic" } },
]

FeedbackFormatter.DEFAULT_SUBS = {
	firstName: "Javon",
	textVariety: "fiction",
	bookTitle: "A Super Fake Book"
}

module.exports = FeedbackFormatter;


// WEBPACK FOOTER //
// ./modules/lib/interface/FeedbackFormatter.js